import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import srOnly from '@helpers/srOnly';
import { link } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  ${transition('opacity')};

  --textLinkColour: ${brand.global.black};

  position: relative;

  &:has(input[aria-disabled='true'], button[aria-disabled='true']) {
    opacity: 0.5;
    pointer-events: none;
  }
`;
const Form = styled.form `
  ${transition('border-color')};

  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 50px;
  border: 1px solid ${rgba(brand.grey.dark, 0.6)};
  width: 100%;
  padding: 0 12px;
  height: ${fluid(36, 50)};

  &:focus-within {
    border-color: ${brand.grey.dark};
  }

  &:has(span) {
    border-color: ${brand.validation.invalid} !important;
  }
`;
const Label = styled.label `
  ${srOnly};
`;
const Input = styled.input `
  ${fonts.lato.regular};

  border: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 22px;
  flex: 1;
  color: ${brand.global.black};

  &::placeholder {
    color: ${brand.grey.dark};
  }
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('transform')};

  order: -1;
  border-radius: 50%;

  svg {
    display: block;
    width: 24px;
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-width: 1px;
  }

  &:focus-visible,
  &:hover {
    transform: scale(1.1);
  }
`;
const Suggestions = styled.ul `
  ${transition('opacity, transform')};

  position: absolute;
  top: calc(100% + 16px);
  left: 0;
  background-color: ${brand.primary.grey};
  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 23px;
  padding: 12px;
  border-radius: 10px;
  min-width: 252px;
  max-height: 500px;
  overflow: auto;

  ${Container}:has(${Input}[aria-expanded='false']) & {
    opacity: 0;
    pointer-events: none;
    transform: translateY(-20px);
  }

  @media ${from(Device.DesktopSmall)} {
    ${scrollbars};
  }
`;
const AutosuggestOption = styled.button `
  ${ButtonReset};
  ${fonts.lato.semiBold};
  ${link};

  font-size: 16px;
  line-height: 32px;
`;
const SearchboxStyles = {
    Container,
    Button,
    Label,
    Input,
    AutosuggestOption,
    Form,
    Suggestions,
};
export default SearchboxStyles;
